import {
  AmlDetails,
  CommonLayout,
  CommonLayoutForPOA,
  Footer,
  SendbackDialog,
} from '../commonComponents';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {
  Box,
  Button,
  CardMedia,
  Grid,
  IconButton,
  Typography,
  Dialog,
  Tooltip,
} from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getApplicationDetails,
  getDocuments,
  isFormValidForSubmission,
  updateApplication,
  // updateApplicationByRTA,
} from '../../redux-store/actions/application';
import ContactDetails from './ContactDetails';
import KycDetails from './kycDetails';
import FatcaDetails from './FatcaDetails';
import NomineeDetails from './nomineeDetails';
import InvestAndPaymentDetails from './InvestmentAndPayment';
import BankDetails from './BankDetails';
import DocumentDetails from './DocumentDetails';
import {
  ApplicationProps,
  Document,
  PAYMENT_DETAILS,
  SendBackType,
  esignApplicationResponse,
} from '../../redux-store/types/api-types';
import ContributorDetails from './InvestorWithoutPan/contributor';
import ContributorDetailsWithPan from './InvestorWithPan/ContributorDetails';
import {
  REJECTED_ROLES,
  USER_ROLES,
  APPLICATION_STATUS,
  ApplicationStatusBasedOnRole,
  APPLICATION_TYPE,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  IndividualApplicationStatusBasedOnRole,
  APPLICATION_STATUS_AMCAPPROVER_individual,
  APPLICATION_LISTING_STATUS,
  ApplicationSourceMaster,
  ESIGN_STATUS,
} from '../../utils/constant';
import { RootState, RootStateType } from '../../redux-store/reducers';
import { useHistory, useRouteMatch } from 'react-router';
import * as yup from 'yup';
import { Formik } from 'formik';
import CloseIcon from '@mui/icons-material/Close';
import { MFTextField } from '../../lib/formik';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import LoadingButton from '@mui/lab/LoadingButton';
import { formatShortDateAndTime } from '../../utils/date';
import {
  AMCApproverLoggedIn,
  // RTAApproverEnableCheckForIndividual,
  // RTAApproverLoggedIn,
  applyRoleBasedStatus,
  checkIfApplicationIsNonIndividual,
  getActionLabel,
  handleDownload,
  IsInvestorWithPAN,
  scrollToBottom,
  // isRtaSendBackToMaker,
  sendApplication_Nri,
  isOverseasBank,
  isPaymentStepComplete,
  isOverseasBankApplication,
  ESIGN_MESSAGE,
  isInvestorEsignStep,
} from '../../utils/utilityFunctions';
import { NonIndividualApplicationLayout } from '../NonIndividualApplicationDetails';
import { showError } from '../../redux-store/actions/auth';
import { ConfirmationDialog } from '../commonComponents';
import DistributorDetails from './rmDistributor';
import Comments from './Comments';
import {
  createLumpsumPayment,
  getAvailableBanks,
  getNationalityList,
  getPaymentStatus,
  updatePaymentType,
} from '../../redux-store/actions';
import { PaymentPopup } from '../Investments/PaymentMode';
import { esignApplication } from '../../redux-store/actions/onBoarding';
import { PaymentFailurePopup } from '../Investments/PaymentFailurePopup';
import { PaymentSuccessPopup } from '../Investments/PaymentSuccessPopup';
import { UPDATE_APPLICATION_SUCCESS } from '../../redux-store/types/application';
import { OfflinePaymentEsignPopup } from '../Investments/OfflinePaymentEsignPopup';
import Loader from '../../utils/Loader';
import { addressRegex } from '../../utils/regex';

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: '10px',
  marginLeft: '2px',
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  letterSpacing: '0.5px',
}));
export const ItemDetails = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  fontSize: '16px',
  marginLeft: '2px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  maxWidth: '100%',
  overflowWrap: 'anywhere',
}));
export const Gridstyles = styled('div')(({ theme }) => ({
  paddingLeft: '10%',
  [theme.breakpoints.only('xs')]: {
    paddingLeft: 0,
  },
}));

export function RejectedDetails({
  title,
  description,
}: {
  title: string | null;
  description: string | null;
}): JSX.Element {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontSize: 17, fontWeight: 500, color: 'text.secondary' }}>
          {title}:{' '}
          <Typography
            component="span"
            sx={{
              color: 'text.secondary',
              fontSize: '16px',
              letterSpacing: '0.4px',
              fontWeight: 700,
              ml: { sm: 0.5 },
            }}>
            {description}
          </Typography>
        </Typography>
      </Grid>
    </>
  );
}

export function ApplicationDetailsCommonLayout({
  loading,
  application,
}: {
  loading: boolean;
  application: ApplicationProps;
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <>
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: 'white',
            zIndex: 9999, // Ensures it's above all other content
          }}>
          <Loader size={60} speed={2} />
        </Box>
      )}
      {application && (
        <>
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
            }}
            mb={3}>
            <Box sx={{ p: 2 }}>
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  mb={2}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                    }}>
                    Application ID: {application.applicationNumber}
                  </Typography>
                  {(application.status === 'completed' ||
                    ApplicationSourceMaster[application.applicationSource || ''] ===
                      ApplicationSourceMaster.migration) &&
                    (application.folio_no || application.xalt_folio_no) && (
                      <Typography
                        sx={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: 'text.secondary',
                        }}>
                        Folio Number: {application.folio_no || application.xalt_folio_no}
                      </Typography>
                    )}
                  <Typography
                    className={
                      application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                        ? role === USER_ROLES.AMCAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : !checkIfApplicationIsNonIndividual(application) &&
                          role === USER_ROLES.AMCAPPROVER
                        ? IndividualApplicationStatusBasedOnRole[role][application.status]
                        : APPLICATION_LISTING_STATUS[application.status]
                    }
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                      '&.Draft .MuiTypography-root': {
                        color: 'rgba(51, 127, 201, 0.7)',
                      },
                      '&.Completed .MuiTypography-root': {
                        fontWeight: 600,
                        color: 'rgba(35, 133, 63, 0.7)',
                      },
                      '&.Rejected .MuiTypography-root': {
                        color: '#BD2932',
                        fontWeight: 500,
                      },
                    }}>
                    Status:{' '}
                    <Typography
                      component="span"
                      sx={{
                        color: '#B78813',
                        fontSize: '16px',
                        letterSpacing: '0.4px',
                        ml: 0.5,
                      }}>
                      {application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                        ? role === USER_ROLES.AMCAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : !checkIfApplicationIsNonIndividual(application) &&
                          role === USER_ROLES.AMCAPPROVER
                        ? IndividualApplicationStatusBasedOnRole[role][application.status]
                        : APPLICATION_LISTING_STATUS[application.status]}
                    </Typography>
                  </Typography>
                  {[
                    USER_ROLES.RM,
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.SUBDISTRIBUTOR,
                    USER_ROLES.AMCAPPROVER,
                    USER_ROLES.AMC_ADMIN,
                  ].includes(role) &&
                    application.signedLeegalityFile?.url && (
                      <Tooltip title={'Download'}>
                        <IconButton
                          sx={{
                            p: 0,
                            pr: 0.5,
                            ':hover': {
                              bgcolor: '#F4FCFC',
                            },
                            cursor: 'pointer',
                            pointerEvents: 'all',
                          }}
                          onClick={async () => {
                            try {
                              application?.signedLeegalityFile?.url &&
                                (await handleDownload(
                                  application?.signedLeegalityFile?.url as string,
                                  `${application.applicationNumber}.pdf`
                                ));
                            } catch (e) {
                              console.error((e as Error).message);
                            }
                          }}>
                          <CardMedia
                            component="img"
                            src={'/images/download-icon.png'}
                            alt="Download"
                            sx={{ width: '25px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                </Grid>
                {application.status === 'rejected' && (
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={1}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <RejectedDetails
                      title={'Rejected by'}
                      description={REJECTED_ROLES[application.rejectedByRole]}
                    />
                    <RejectedDetails
                      title={'Rejected on'}
                      description={formatShortDateAndTime(application.rejectedAt)}
                    />
                    <RejectedDetails
                      title={'Reason for rejection'}
                      description={application.rejectedReason}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>
          {USER_ROLES.INVESTOR !== role && role && (
            <AmlDetails
              applicants={application.applicants}
              applicationType={application.applicationType}
            />
          )}
          {role && role !== USER_ROLES.INVESTOR && application.comments?.length > 0 && (
            <Comments application={application} />
          )}
          {role !== USER_ROLES.INVESTOR && role && <DistributorDetails application={application} />}
          {IsInvestorWithPAN(application?.flowType || '') ? (
            <ContributorDetailsWithPan
              application={application}
              modeOfHolding={application.modeOfHolding}
            />
          ) : (
            <ContributorDetails
              application={application}
              modeOfHolding={application.modeOfHolding}
              applicationSource={application.applicationSource}
            />
          )}
          <ContactDetails applicants={application.applicants} />
          <KycDetails
            applicants={application.applicants}
            fundFlowType={application.fundFlowType || ''}
            createdAt={application?.createdAt || ''}
          />
          <FatcaDetails
            applicants={application.applicants}
            createdAt={application?.createdAt || ''}
          />
          <NomineeDetails nominees={application.nominees} />
          <InvestAndPaymentDetails application={application} />
          <BankDetails
            banks={application.banks}
            paymentModeDeclaration={application.paymentModeDeclaration}
          />
          <DocumentDetails application={application} />
        </>
      )}
    </>
  );
}

const RejectApproveButtons = ({
  handleOpen,
  handleDialogOpen,
  approve,
  reject,
  sendBack,
  handleSendBack,
}: {
  handleOpen: () => void;
  handleDialogOpen: () => void;
  approve: boolean;
  reject: boolean;
  sendBack: boolean;
  handleSendBack: () => void;
}): JSX.Element => {
  return (
    <Grid display="flex" justifyContent="center" alignItems="center">
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={reject}
        variant="outlined"
        // sx={{
        //   fontSize: 15,
        //   minWidth: 180,
        //   letterSpacing: 2,
        //   fontWeight: 400,
        // }}
        sx={{
          color: 'primary.main',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          mr: 3,
        }}
        onClick={handleOpen}
        disabled={approve || sendBack}>
        Reject
      </LoadingButton>
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={approve}
        variant="contained"
        // sx={{
        //   fontSize: 15,
        //   minWidth: 180,
        //   letterSpacing: 2,
        //   fontWeight: 400,
        // }}
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleDialogOpen}
        disabled={reject || sendBack}>
        Approve
      </LoadingButton>
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={sendBack}
        variant="contained"
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleSendBack}
        disabled={reject || approve}>
        Send Back
      </LoadingButton>
      {/* <Button
        variant="contained"
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleDialogOpen}>
        Approve
      </Button> */}
    </Grid>
  );
};

//Read only view for POA and Non Individual Application for AMC Approver,Individual Application for AMC Approver and POA Approver
const PoaOrNIApplicationDetails = ({
  loading,
  application,
}: {
  loading: boolean;
  application: ApplicationProps;
}): JSX.Element => {
  const { status, editable, applicationType, flowType = '' } = application || {};
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleDialogOpen = () => setOpenDialog(true);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [approveClickedorSendBack, setApproveClickedorSendBack] = useState(false);

  const handleClose = () => {
    setOpen(false), setApproveLoading(false);
  };
  const handleDialogClose = () => {
    setOpenDialog(false), setRejectLoading(false);
  };

  const handleSendBack = () => {
    setOpenSendBackDialog(true), setApproveClickedorSendBack(true);
  };

  // const handleSendBackAMCtoRTA = () => setOpenSendBackDialog(true);
  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false), setApproveClickedorSendBack(false);
  };

  const initialValues: Partial<ApplicationProps> = { rejectedReason: '' };
  const resonValidation = yup.object().shape({
    rejectedReason: yup
      .string()
      .required('Please enter the reason for rejection')
      .matches(
        addressRegex,
        "Invalid format [special characters are not allowed except -/',&()#:.]"
      ),
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onApproveByAMCApprover = async (values: SendBackType) => {
    await dispatch(
      updateApplication({
        body: {
          ...application,
          ...(values.comment ? { comment: values.comment } : {}),
          status:
            USER_ROLES.POAAPPROVER === role &&
            APPLICATION_LISTING_STATUS[application?.status] ===
              APPLICATION_LISTING_STATUS.sent_to_poa_approver
              ? 'sent_to_amc_approver'
              : AMCApproverLoggedIn(role) &&
                APPLICATION_LISTING_STATUS[application?.status] ===
                  APPLICATION_LISTING_STATUS.sent_to_amc_approver
              ? application?.hasPOA
                ? 'sent_to_authorised_signatories'
                : sendApplication_Nri(application) ||
                  (AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                    !checkIfApplicationIsNonIndividual(application))
                ? 'sent_to_applicant1'
                : 'sent_to_authorised_signatories'
              : application?.status,
        },
        applicationId: application.id,
        flowType,
      })
    );
  };

  const onSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleClose();
      setRejectLoading(true);
      if (application) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              rejectedReason: values.rejectedReason,
              status: 'rejected',
            },
            applicationId: application.id,
            flowType,
          })
        );
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setRejectLoading(false);
    }
  };

  // const ApplicableToRTAApproveOrSendBack =
  //   RTAApproverLoggedIn(role) && RTAApproverEnableCheckForIndividual();
  // it will sends back application to desired status like from AMC/RTA/POA approver to draft, draft to first approver(POA cases to poa otherwise to AMC approver), AMC to RTA
  const onSendBackSubmit = async (values: SendBackType) => {
    try {
      handleSendBackClose();
      approveClickedorSendBack ? setSendBackLoading(true) : setApproveLoading(true);
      if (application) {
        // if (ApplicableToRTAApproveOrSendBack) {
        //   await dispatch(
        //     updateApplicationByRTA({
        //       body: {
        //         id: application.id,
        //         status: isRtaSendBackToMaker(values?.sendBackTo) ? 'draft' : 'sent_to_amc_approver',
        //         comment: values.comment,
        //         rtaSentBack: true,
        //         ...(isRtaSendBackToMaker(values?.sendBackTo) ? { applicationSentBack: true } : {}),
        //       },
        //       applicationId: application.id,
        //     })
        //   );
        // } else
        if (!approveClickedorSendBack) {
          await onApproveByAMCApprover({ comment: values.comment });
        } else {
          await dispatch(
            updateApplication({
              body: {
                ...application,
                comment: values.comment,
                status: 'draft',
                applicationSentBack: true,
              },
              applicationId: application.id,
              flowType,
            })
          );
        }
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
      setApproveLoading(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
      }}>
      <CommonLayoutForPOA />
      <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: { xs: 7, sm: 10 } }} ref={applicationDetailRef}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 2,
            justifyContent: 'space-between',
            // mt: 5,
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{ height: 'fit-content', p: 0 }}
              component={RouterLink}
              to="/applications-list"
              disabled={approveLoading || rejectLoading || sendBackLoading}>
              <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main' }}>
              Application Details
            </Typography>
          </Box>
          {editable && (
            <IconButton>
              <CardMedia
                component="img"
                src="/images/edit-icon-outlined.svg"
                alt="Edit Icon"
                sx={{ width: 'unset' }}
                onClick={() =>
                  history.push(
                    role === USER_ROLES.POAAPPROVER
                      ? `/investment-details/edit-application`
                      : !checkIfApplicationIsNonIndividual(application) &&
                        USER_ROLES.AMCAPPROVER === role
                      ? `/investment-details/edit-application`
                      : `/non-individual-application-edit`,
                    {
                      id: application?.id,
                    }
                  )
                }
              />
            </IconButton>
          )}
        </Box>
        <IconButton
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton>
        {applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (
          <NonIndividualApplicationLayout loading={loading} application={application} />
        ) : (
          <ApplicationDetailsCommonLayout loading={loading} application={application} />
        )}
        {application &&
          ((USER_ROLES.AMCAPPROVER === role && status === 'sent_to_amc_approver') ||
          (USER_ROLES.POAAPPROVER === role && status === 'sent_to_poa_approver') ? (
            <RejectApproveButtons
              handleOpen={handleOpen}
              handleDialogOpen={handleDialogOpen}
              approve={approveLoading}
              reject={rejectLoading}
              sendBack={sendBackLoading}
              handleSendBack={handleSendBack}
            />
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                sx={{
                  color: 'common.white',
                  minWidth: '200px',
                  mt: 4,
                  fontWeight: 600,
                  lineHeight: 1.5,
                }}
                onClick={() => {
                  history.push('/applications-list');
                }}>
                Done
              </Button>
            </Box>
          ))}
        <Dialog
          onClose={handleClose}
          open={open}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 18,
                fontWeight: 500,
                textAlign: 'center',
              },
            }}>
            <Typography sx={{ color: 'primary.main' }}>
              Are you sure you want to{' '}
              <Typography component="span" sx={{ color: '#BD2932' }}>
                Reject
              </Typography>{' '}
              the application
            </Typography>
            <Typography sx={{ color: '#BD2932', mt: 5 }}>
              {' '}
              Give reason for application rejection *
            </Typography>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={resonValidation}>
              {({ handleSubmit }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <MFTextField
                    name="rejectedReason"
                    multiline
                    rows={4}
                    placeholder="Type your answer here..."
                  />

                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <Button
                      onClick={() => {
                        handleClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      type="submit">
                      Continue
                    </Button>
                  </Grid>
                </Box>
              )}
            </Formik>
          </Box>
        </Dialog>
        <Dialog
          onClose={handleDialogClose}
          open={openDialog}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <IconButton onClick={handleDialogClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 20,
                fontWeight: 500,
                textAlign: 'center',
              },
            }}>
            <Typography sx={{ color: 'primary.main' }}>
              Are you sure you want to{' '}
              <Typography component="span" sx={{ color: 'green' }}>
                Approve
              </Typography>{' '}
              the application
            </Typography>
          </Box>
          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
            <Button
              onClick={() => {
                handleDialogClose();
              }}
              variant="outlined"
              sx={{
                fontSize: 15,
                color: 'primary.main',
                minWidth: 180,
                letterSpacing: 2,
                fontWeight: 500,
              }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                fontSize: 15,
                minWidth: 180,
                letterSpacing: 2,
                fontWeight: 400,
              }}
              onClick={async () => {
                try {
                  handleDialogClose();
                  setApproveLoading(true);
                  await dispatch(
                    updateApplication({
                      body: {
                        ...application,
                        status:
                          USER_ROLES.POAAPPROVER === role &&
                          application?.status === 'sent_to_poa_approver'
                            ? 'sent_to_amc_approver'
                            : USER_ROLES.AMCAPPROVER === role &&
                              application?.status === 'sent_to_amc_approver'
                            ? application?.hasPOA
                              ? 'sent_to_authorised_signatories'
                              : sendApplication_Nri(application) ||
                                (AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                                  !checkIfApplicationIsNonIndividual(application))
                              ? 'sent_to_applicant1'
                              : 'sent_to_authorised_signatories'
                            : application?.status,
                      },
                      applicationId: application.id,
                      flowType,
                    })
                  );
                  history.push('/applications-list');
                } catch (e) {
                  console.error((e as Error).message);
                } finally {
                  setApproveLoading(false);
                }
              }}>
              Continue
            </Button>
          </Grid>
        </Dialog>
        <SendbackDialog
          handleSendBackClose={() => handleSendBackClose()}
          openSendBackDialog={openSendBackDialog}
          onSendBackSubmit={(values: SendBackType) => onSendBackSubmit(values)}
          role={role}
          sendBackLoading={sendBackLoading}
          extraTexttodisplay={approveClickedorSendBack}
        />
      </Box>
      <Footer />
    </Box>
  );
};

export default function ApplicationDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [application, setApplication] = useState<ApplicationProps>();
  const { application } = useSelector((store: RootStateType) => store.application);

  const applicationDetailRef = useRef<HTMLDivElement>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const { path } = useRouteMatch();
  const [showPaymentSuccessPopup, setShowPaymentSuccessPopup] = useState(false);
  const [showPaymentFailurePopup, setShowPaymentFailurePopup] = useState(false);
  const { editable, hasPOA, applicationSentBack = false, flowType = '' } = application || {};
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [sendBackLoading, setSendBackLoading] = useState(false);
  const [showPaymentModePopup, setShowPaymentModePopup] = useState(false);
  const [isOnlinePaymentEnabled, setIsOnlinePaymentEnabled] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [showOfflinePaymentEsignPopup, setShowOfflinePaymentEsignPopup] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const actualStatus = urlParams.get('status')?.toLowerCase();
        const paymentStatus = urlParams.get('paymentStatus');
        const orderId = urlParams.get('order_id');

        // This will update Redux state automatically
        const _application = (await dispatch(
          getApplicationDetails(id, '', actualStatus)
        )) as unknown as ApplicationProps;

        const paymentDetails = _application?.payment;
        const paymentType = _application?.paymentType;
        const payment_status = paymentDetails?.status;

        if (
          (payment_status &&
            ['pending', 'success', 'failure', 'expired'].includes(payment_status || '') &&
            paymentType === 'online') ||
          paymentType === 'offline'
        ) {
          setPaymentCompleted(true);
        }
        if (orderId) {
          try {
            const paymentStatusResponse = (await dispatch(
              getPaymentStatus(orderId)
            )) as unknown as {
              status?: string;
            };
            const status = (paymentStatusResponse?.status || '').toLowerCase();
            if (['pending', 'success'].includes(status || '')) {
              setShowPaymentSuccessPopup(true);
              setPaymentCompleted(true);
            } else if (['failure', 'expired'].includes(status || '')) {
              setShowPaymentFailurePopup(true);
            }
          } catch (e) {
            typeof e === 'string' && dispatch(showError(e as string));
            setShowPaymentFailurePopup(true);
          } finally {
            window.history.replaceState({}, document.title, window.location.pathname);
          }
          return;
        }
        if (actualStatus) {
          if (['pending', 'success'].includes(actualStatus || '')) {
            setShowPaymentSuccessPopup(true);
            setPaymentCompleted(true);
            // window.history.replaceState({}, document.title, window.location.pathname);
          } else if (['failure', 'expired'].includes(actualStatus || '')) {
            setShowPaymentFailurePopup(true);
            // window.history.replaceState({}, document.title, window.location.pathname);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, [dispatch, id]);

  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const onSendBackSubmit = async (values: SendBackType) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      const { id, status } = application || {};
      if (id) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              status: hasPOA
                ? 'sent_to_poa_approver'
                : sendApplication_Nri(application) ||
                  (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                ? 'sent_to_amc_approver'
                : !AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)
                ? 'sent_to_applicant1'
                : status,
              comment: values.comment,
              applicationSentBack: false,
            },
            applicationId: id,
            flowType,
          })
        );
        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const { id, status } = application || {};
      // const paymentStatus = (application?.payment?.status || '').toLowerCase();
      setIsSubmitting(true);
      if (id) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              status: hasPOA
                ? 'sent_to_poa_approver'
                : // : (status === 'draft' || status === 'sent_to_amc_approver') &&
                sendApplication_Nri(application) ||
                  (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                ? 'sent_to_amc_approver'
                : !AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)
                ? 'sent_to_applicant1'
                : // ? paymentStatus.includes('success')
                  //   ? 'payment_success'
                  //   : 'payment_pending'
                  status,
            },
            applicationId: id,
            flowType,
          })
        );
        // if (role === USER_ROLES.INVESTOR) {
        //   if (
        //     paymentCompleted &&
        //     ![ESIGN_STATUS.SIGNED, ESIGN_STATUS.EXPIRED].includes(
        //       application?.signDetails?.status || ''
        //     )
        //   ) {
        //     await handleEsign();
        //     return;
        //   }
        //   await handleMakePayment();
        //   return;
        // }
        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMakePayment = async () => {
    try {
      setIsSubmitting(true);
      setShowPaymentFailurePopup(false);
      if (!application?.id) {
        dispatch(showError('Application details are missing. Please refresh and try again.'));
        return;
      }
      if (application.applicationFlow === 'DIY' && !application?.payment?.payment_url) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              status: 'sent_to_applicant1',
            },
            applicationId: application.id,
            flowType: application.flowType,
          })
        );
      }
      if (application?.payment?.payment_url) {
        window.open(application?.payment?.payment_url, '_blank');
        return;
      }
      const selectedBank =
        application?.banks?.find((bank) => bank?.defaultBankAccount) || application?.banks?.[0];
      const isOverseas = isOverseasBank(selectedBank?.investorBankType);
      const bankCode = isOverseas ? selectedBank?.swiftCode || '' : selectedBank?.ifscCode || '';
      // const ifscCode = selectedBank?.ifscCode || '';

      if (!bankCode) {
        dispatch(
          showError(
            isOverseas
              ? 'Bank SWIFT code is missing. Please update bank details and try again.'
              : 'Bank IFSC code is missing. Please update bank details and try again'
          )
        );
        return;
      }
      const availableBanksResponse = (await dispatch(
        getAvailableBanks({
          trtype: 'Lumpsum',
          paymode: 'Net Banking',
          ifsc: bankCode,
        })
      )) as unknown as { isNetbankingAvailable?: boolean };
      setIsOnlinePaymentEnabled(Boolean(availableBanksResponse?.isNetbankingAvailable));
      setShowPaymentModePopup(true);
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePaymentModeConfirm = async (paymentType: string, paymentMode: string) => {
    try {
      if (!application?.id) {
        dispatch(showError('Application details are missing. Please refresh and try again.'));
        return;
      }
      await dispatch(
        updatePaymentType({ applicationId: application?.id || '', paymentType: paymentType })
      );
      if (paymentMode !== 'offline') {
        const callbackSuccessUrl = `${window.location.origin}${window.location.pathname}?paymentStatus=success`;
        const callbackFailureUrl = `${window.location.origin}${window.location.pathname}?paymentStatus=failed`;
        const paymentCreateResponse = (await dispatch(
          createLumpsumPayment({
            applicationId: application?.id,
            payment_mode: paymentMode,
            callback_success_url: callbackSuccessUrl,
            callback_failure_url: callbackFailureUrl,
          })
        )) as unknown as { url?: string };

        const paymentUrl = paymentCreateResponse?.url;

        if (paymentUrl) {
          window.open(paymentUrl, '_blank');
          return;
        }
        dispatch(showError('Unable to initiate payment. Please try again.'));
      } else if (paymentMode === 'offline') {
        setPaymentCompleted(true);
        setShowOfflinePaymentEsignPopup(true);
      }
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
    }
  };

  const handleContinueOffline = async () => {
    try {
      if (!application?.id) {
        dispatch(showError('Application details are missing. Please refresh and try again.'));
        return;
      }
      await dispatch(updatePaymentType({ applicationId: application.id, paymentType: 'offline' }));
      setShowPaymentFailurePopup(false);
      setShowOfflinePaymentEsignPopup(true);
      setPaymentCompleted(true);
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
    }
  };

  const handleOverseasProceedToEsign = async () => {
    try {
      if (!application?.id) {
        dispatch(showError('Application details are missing. Please refresh and try again.'));
        return;
      }
      await dispatch(updatePaymentType({ applicationId: application.id, paymentType: 'offline' }));
      setPaymentCompleted(true);
      await handleEsign();
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
    }
  };

  const handleEsign = async () => {
    try {
      setIsSubmitting(true);

      let referenceId = application?.applicant1ReferenceId;
      let currentApp = application;

      // Only call updateApplication if referenceId is missing
      if (!referenceId) {
        const updatedApplication = (await dispatch(
          updateApplication({
            body: { ...application, status: 'sent_to_applicant1' },
            applicationId: application?.id || '',
            flowType: application?.flowType || '',
          })
        )) as unknown as ApplicationProps;

        currentApp = updatedApplication;
        referenceId = updatedApplication?.applicant1ReferenceId;
      }

      const nationalitiesMdmsMasters = await dispatch(getNationalityList());
      const documentsResponse = (await dispatch(
        getDocuments(currentApp?.flowType || '', currentApp?.fundFlowType || '')
      )) as unknown as Document;

      const currentSignStatus = currentApp?.signDetails?.status || '';
      if (ESIGN_STATUS.PENDING_SIGNATURE !== currentSignStatus) {
        ESIGN_STATUS.NOT_GENERATED === currentSignStatus
          ? await isFormValidForSubmission(
              currentApp as ApplicationProps,
              true,
              true,
              nationalitiesMdmsMasters,
              documentsResponse,
              role
            )
          : await isFormValidForSubmission(
              currentApp as ApplicationProps,
              true,
              false,
              nationalitiesMdmsMasters,
              documentsResponse,
              role
            );
      }

      const { signDetails, flowType = '' } = currentApp || {};
      if (!referenceId) {
        dispatch(showError('Reference ID is missing for this application.'));
        return;
      }

      const response = (await dispatch(
        esignApplication(referenceId, flowType)
      )) as unknown as esignApplicationResponse;

      // No setApplication here — reducer will update store
      dispatch({
        type: UPDATE_APPLICATION_SUCCESS,
        body: { ...currentApp, signDetails: response },
      });

      if (response?.url) {
        window.open(response.url, '_blank');
        return;
      }
      if (signDetails?.url) {
        window.open(signDetails.url, '_blank');
        return;
      }
      dispatch(showError('Unable to generate e-sign URL. Please try again.'));
    } catch (e) {
      dispatch(showError(typeof e === 'string' ? e : (e as Error)?.message || 'e-Sign failed'));
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return [
    USER_ROLES.AMC_ADMIN,
    USER_ROLES.RM,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.AMC_ADMIN,
    USER_ROLES.INVESTOR,
    USER_ROLES.AMC_VIEWER,
  ].includes(role) ? (
    <CommonLayout>
      <>
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}
          ref={applicationDetailRef}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{ height: 'fit-content', p: 0 }}
              component={RouterLink}
              to="/applications">
              <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              component="h1"
              sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Application Details
            </Typography>
          </Box>
          {editable && (
            <IconButton>
              <CardMedia
                component="img"
                src="/images/edit-icon-outlined.svg"
                alt="Edit Icon"
                sx={{ width: 'unset' }}
                onClick={() => history.push(`/application`, { id })}
              />
            </IconButton>
          )}
        </Box>
        <IconButton
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton>
        <ApplicationDetailsCommonLayout
          loading={loading}
          application={application as ApplicationProps}
        />
        {path === '/application-preview/:id' && editable && (
          <Box sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              sx={{
                color: 'common.white',
                minWidth: '200px',
                mt: 4,
                fontWeight: 600,
                lineHeight: 1.5,
                fontSize: '16px',
              }}
              onClick={async () => {
                if (role === USER_ROLES.INVESTOR) {
                  const signStatus = application?.signDetails?.status || '';
                  const paymentStepComplete = isPaymentStepComplete(paymentCompleted, application);
                  const isOverseas = isOverseasBankApplication(application);
                  // Case 1: Payment not completed → Make Payment (overseas skips to e-Sign)
                  if (!paymentStepComplete) {
                    await handleMakePayment();
                    return;
                  }
                  // Case 2: Payment done (or overseas bank) but e-sign not yet completed → e-Sign
                  if (
                    ![ESIGN_STATUS.SIGNED, ESIGN_STATUS.EXPIRED, ESIGN_STATUS.COMPLETED].includes(
                      signStatus
                    )
                  ) {
                    if (isOverseas && !paymentCompleted) {
                      await handleOverseasProceedToEsign();
                      return;
                    }
                    await handleEsign();
                    return;
                  }
                  // Case 3: Payment + e-sign done → redirect to applications
                  window.location.href = '/applications';
                  return;
                }
                // Non-investor roles
                setDialog(true);
              }}
              disabled={isSubmitting || sendBackLoading}>
              {`${getActionLabel(role, application, paymentCompleted)} ${
                isSubmitting ? '...' : ''
              }`}
            </Button>
            {isInvestorEsignStep(role, application, paymentCompleted) && (
              <Typography
                sx={{
                  mt: 2,
                  fontSize: 14,
                  fontWeight: 700,
                  color: 'text.primary',
                  lineHeight: 1.7,
                  textAlign: 'center',
                }}>
                ({ESIGN_MESSAGE})
              </Typography>
            )}
          </Box>
        )}
        {isSubmitting && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: 'white',
              zIndex: 9999, // Ensures it's above all other content
            }}>
            <Loader
              size={60}
              speed={2}
              text="Getting the forms ready for you to sign, please wait for a few moments."
            />
          </Box>
        )}
        <SendbackDialog
          handleSendBackClose={() => handleSendBackClose()}
          openSendBackDialog={openSendBackDialog}
          onSendBackSubmit={(values: SendBackType) => onSendBackSubmit(values)}
          role={role}
          sendBackLoading={sendBackLoading}
        />
        <ConfirmationDialog
          message={`Are you sure you want to send it to ${
            application?.hasPOA
              ? 'POA Approver'
              : sendApplication_Nri(application) ||
                (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
              ? 'AIF Approver'
              : 'Investor'
          }`}
          open={openDialog}
          setOpen={() => setDialog(false)}
          onSave={async () => {
            setDialog(false);
            (sendApplication_Nri(application) || applyRoleBasedStatus(role)) && applicationSentBack
              ? handleSendBack()
              : handleSubmit();
          }}
          onCancel={() => setDialog(false)}
        />
        {showPaymentModePopup && (
          <PaymentPopup
            onClose={() => setShowPaymentModePopup(false)}
            onConfirm={handlePaymentModeConfirm}
            isOnlinePaymentEnabled={isOnlinePaymentEnabled}
          />
        )}
        {showPaymentSuccessPopup && (
          <PaymentSuccessPopup
            onClose={() => setShowPaymentSuccessPopup(false)}
            onClickOk={async () => {
              setShowPaymentSuccessPopup(false);
              await handleEsign();
            }}
            okDisabled={isSubmitting}
          />
        )}
        {showPaymentFailurePopup && (
          <PaymentFailurePopup
            onClickOk={async () => {
              setShowPaymentFailurePopup(false);
              await handleEsign();
            }}
          />
        )}
        {showOfflinePaymentEsignPopup && (
          <OfflinePaymentEsignPopup
            onClose={() => setShowOfflinePaymentEsignPopup(false)}
            onProceedWithEsign={async () => {
              setShowOfflinePaymentEsignPopup(false);
              await handleEsign();
            }}
            proceedDisabled={isSubmitting}
          />
        )}
      </>
    </CommonLayout>
  ) : (
    <PoaOrNIApplicationDetails loading={loading} application={application as ApplicationProps} />
  );
}
